import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-left px-[16px] flex" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Aplicar Filtros")
], -1)
const _hoisted_2 = { class: "text-left input w-full flex flex-col gap-2 input mt-2 max-h-[420px] px-[8px] overflow-y-scroll" }
const _hoisted_3 = {
  key: 0,
  class: "w-full mt-3",
  "data-testid": "dashboard-filter-coverage-row"
}
const _hoisted_4 = { class: "flex justify-between gap-2 mt-3" }
const _hoisted_5 = { class: "flex md:flex-nowrap flex-wrap justify-between gap-2" }
const _hoisted_6 = { class: "flex flex-col gap-2" }
const _hoisted_7 = { class: "flex flex-wrap md:flex-nowrap justify-between max-w-2xl gap-2" }
const _hoisted_8 = { class: "flex justify-between max-w-2xl gap-2" }
const _hoisted_9 = { class: "flex justify-between max-w-2xl gap-2" }
const _hoisted_10 = { class: "flex gap-2" }

import { ref, onBeforeUnmount, computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import { claimFilterModalRender } from './filterModalRenderOwner'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import { stationTypes, stationOur, openedStationOpts } from '@/hooks/useCommon'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import { filterDashboardStates, clearFilterDashboardOpt } from './useFilterDashboard'
import { useStationStore } from '@/pinia-store/useStationStore'
import CoverageStatusFilterChips from '@/components/Coverage/CoverageStatusFilterChips.vue'
import type { CoverageStatus } from '@/Network/Types/Responses/CoverageResponses'
import { useErrorToast } from '@/composables/useErrorToast'
import { useOperationalGroups } from '@/hooks/useOperationalGroups'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'

const COVERAGE_COUNTS_HINT = 'Contagem das escalas carregadas na grade'

export default /*#__PURE__*/_defineComponent({
  __name: 'filter.dashboard.modal',
  setup(__props) {

const renderClaim = claimFilterModalRender()
const isRenderOwner = computed(() => renderClaim.isOwner())
onBeforeUnmount(renderClaim.release)

const { notifyError } = useErrorToast()
const isLoading = ref(false)
const isLoadingClear = ref(false)
/* ******** Modal Props and Actions Default *********** */
const modalName = EModals.FILTER_STATION
const { modals } = storeToRefs(useModalStore())
const modalStore = useModalStore()

const permissionsStore = usePermissionsStore()

const stationsStore = useStationStore()
// Grupos operacionais sob demanda, ao ABRIR o modal: o componente fica montado na página e
// carregar no mount viraria toast a cada visita quando o endpoint nega (ex.: 403 por papel).
// O hook guarda o cache da sessão e divide a busca em voo (um toast só).
const { options: operationalGroups, load: loadOperationalGroups } = useOperationalGroups()
const operationalGroupOptions = computed(() => operationalGroups.value.map((group) => group.value))

// M10-A: os chips só aparecem quando o BE já devolve `coverageCounts`; senão fica o select legado.
const coverageCounts = computed(() => stationsStore.listStations?.coverageCounts ?? null)
// O BE conta só as escalas do(s) lote(s) já carregados na grade ("Carregar mais" soma).
const setCoverageStatus = (value: CoverageStatus[]) => {
  filterDashboardStates.coverageStatus = value.length ? value : undefined
  // D-B1: com chips, o filtro legado sai (os dois juntos fariam AND no BE).
  if (value.length) filterDashboardStates.openedStation = undefined
}

const handleToggleModal = () => {
  modalStore.toggleModal(modalName)
}
/* **************************************************** */
const handleSubmit = async () => {
  isLoading.value = true
  await setFilters()
}

const handleClearFilters = async () => {
  isLoadingClear.value = true
  clearFilterDashboardOpt()
  await setFilters()
}

const setFilters = async () => {
  try {
    await stationsStore.setFilters(filterDashboardStates)
  } catch (error) {
    // Falha de API da listagem fica em `loadError` da store (ReportErrorState na Dashboard);
    // este catch só pega o que escapar dela — sem engolir, com a mensagem pelo funil.
    notifyError(error, 'Erro ao listar os plantões')
  } finally {
    isLoading.value = false
    isLoadingClear.value = false
    handleToggleModal()
  }
}

watch(
  () => modals.value[modalName],
  (isOpen) => {
    if (isOpen && isRenderOwner.value) loadOperationalGroups()
  },
  { immediate: true }
)

const canReadingStationPaymentRules = computed(() => {
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.StationPaymentRulesReading,
    resourceType: AuthorizationResourcesAndSubjects.Schedule
  })
})

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (isRenderOwner.value)
    ? (_openBlock(), _createBlock(ModalVue, {
        key: 0,
        onClose: handleToggleModal,
        modalActive: _unref(modals)[_unref(modalName)],
        hasFooterBorder: true,
        isFilterModal: ""
      }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_v_row, { class: "pt-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(GhostButton, {
                    onClick: handleClearFilters,
                    width: "100%",
                    text: "Limpar filtros",
                    loading: isLoadingClear.value,
                    disabled: isLoading.value || isLoadingClear.value
                  }, null, 8, ["loading", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(FilledButton, {
                    loading: isLoading.value,
                    onClick: handleSubmit,
                    text: "Aplicar Filtros",
                    height: "52px",
                    width: "100%",
                    disabled: isLoading.value || isLoadingClear.value
                  }, null, 8, ["loading", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (coverageCounts.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(CoverageStatusFilterChips, {
                    class: "w-full",
                    "model-value": _unref(filterDashboardStates).coverageStatus ?? [],
                    counts: coverageCounts.value,
                    "counts-hint": COVERAGE_COUNTS_HINT,
                    "onUpdate:modelValue": setCoverageStatus
                  }, null, 8, ["model-value", "counts"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_text_field, {
                modelValue: _unref(filterDashboardStates).valueMin,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filterDashboardStates).valueMin) = $event)),
                class: "w-full",
                prefix: "R$",
                type: "number",
                label: "Valor Mínimo",
                color: "primary20",
                variant: "outlined",
                density: "compact",
                hint: "Valor da vaga",
                disabled: !canReadingStationPaymentRules.value
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(_component_v_text_field, {
                modelValue: _unref(filterDashboardStates).valueMax,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filterDashboardStates).valueMax) = $event)),
                class: "w-full",
                prefix: "R$",
                type: "number",
                label: "Valor Máximo",
                color: "primary20",
                variant: "outlined",
                density: "compact",
                hint: "Valor da vaga",
                disabled: !canReadingStationPaymentRules.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_text_field, {
                modelValue: _unref(filterDashboardStates).paymentValueMin,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filterDashboardStates).paymentValueMin) = $event)),
                class: "w-full",
                prefix: "R$",
                type: "number",
                label: "Valor aprovado mínimo",
                color: "primary20",
                variant: "outlined",
                density: "compact",
                hint: "Valor aprovado pelo médico",
                disabled: !canReadingStationPaymentRules.value
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(_component_v_text_field, {
                modelValue: _unref(filterDashboardStates).paymentValueMax,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filterDashboardStates).paymentValueMax) = $event)),
                class: "w-full",
                prefix: "R$",
                type: "number",
                label: "Valor aprovado máximo",
                color: "primary20",
                variant: "outlined",
                hint: "Valor aprovado pelo médico",
                density: "compact",
                disabled: !canReadingStationPaymentRules.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_v_autocomplete, {
                  modelValue: _unref(filterDashboardStates).advanceRequested,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(filterDashboardStates).advanceRequested) = $event)),
                  clearable: "",
                  class: "w-full",
                  color: "primary20",
                  label: "Antecipação Solicitada",
                  items: [
              { title: 'Sim', value: true },
              { title: 'Não', value: false }
            ],
                  variant: "outlined",
                  density: "compact",
                  disabled: !canReadingStationPaymentRules.value
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode(_component_v_autocomplete, {
                  modelValue: _unref(filterDashboardStates).advancePaid,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(filterDashboardStates).advancePaid) = $event)),
                  clearable: "",
                  class: "w-full",
                  color: "primary20",
                  label: "Antecipação Paga",
                  items: [
              { title: 'Sim', value: true },
              { title: 'Não', value: false }
            ],
                  variant: "outlined",
                  density: "compact",
                  disabled: !canReadingStationPaymentRules.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_v_autocomplete, {
                  modelValue: _unref(filterDashboardStates).inCash,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(filterDashboardStates).inCash) = $event)),
                  clearable: "",
                  class: "w-full",
                  color: "primary20",
                  label: "Pagamento á vista",
                  items: [
              { title: 'Sim', value: true },
              { title: 'Não', value: false }
            ],
                  variant: "outlined",
                  density: "compact",
                  disabled: !canReadingStationPaymentRules.value
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode(_component_v_autocomplete, {
                  modelValue: _unref(filterDashboardStates).ourTeam,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(filterDashboardStates).ourTeam) = $event)),
                  clearable: "",
                  class: "w-full",
                  color: "primary20",
                  label: "Nosso plantão?",
                  items: _unref(stationOur),
                  variant: "outlined",
                  density: "compact",
                  disabled: !canReadingStationPaymentRules.value
                }, null, 8, ["modelValue", "items", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_v_autocomplete, {
                modelValue: _unref(filterDashboardStates).stationType,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(filterDashboardStates).stationType) = $event)),
                clearable: "",
                class: "w-full",
                color: "primary20",
                label: "Periodicidade",
                items: _unref(stationTypes),
                multiple: "",
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue", "items"]),
              _createVNode(_component_v_autocomplete, {
                modelValue: _unref(filterDashboardStates).operationalGroups,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(filterDashboardStates).operationalGroups) = $event)),
                items: operationalGroupOptions.value,
                label: "Grupo Operacional",
                multiple: "",
                chips: "",
                "closable-chips": "",
                clearable: "",
                variant: "outlined",
                density: "compact",
                class: "w-full",
                color: "primary20"
              }, null, 8, ["modelValue", "items"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              (!coverageCounts.value)
                ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                    key: 0,
                    clearable: "",
                    class: "w-full",
                    color: "primary20",
                    label: "Vaga do plantão",
                    modelValue: _unref(filterDashboardStates).openedStation,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(filterDashboardStates).openedStation) = $event)),
                    items: _unref(openedStationOpts),
                    variant: "outlined",
                    density: "compact"
                  }, null, 8, ["modelValue", "items"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_autocomplete, {
                modelValue: _unref(filterDashboardStates).status,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(filterDashboardStates).status) = $event)),
                clearable: "",
                class: "w-full",
                color: "primary20",
                label: "Status do plantão",
                items: [
            { title: 'Pendente', value: 'waiting' },
            { title: 'Confirmado', value: 'confirmed' }
          ],
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modalActive"]))
    : _createCommentVNode("", true)
}
}

})